import { ActionReducerMap, Store as BaseStore } from '@ngrx/store';

// tslint:disable-next-line: max-line-length
import data, { State as DataState, Action as DataAction, defaultState, selectData, FEATURE_REDUCER_TOKEN as frt} from './data'; // prettier-ignore
export const selectDataSelector = selectData;

export const FEATURE_REDUCER_TOKEN = frt;
// Root store state type
export interface State {
  data: DataState;
}

// Root store action type
export type Action = DataAction;

// The app store type
export type Store = BaseStore<State>;

// Root reducer
export function getInitalState() {
  return { data: { ...defaultState } };
}

export const reducers: ActionReducerMap<State, Action> = {
  data,
};
// Common shared actions
export interface ErrorAction {
  error: Error;
}
